// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"766":"8d3576b0","883":"6cf8eaf3"}[chunkId] + ".chunk.css";
};